export default "__VITE_ASSET__de7e3195__"